import {Module} from 'vuex';
import {RootState} from '@/types';
import ArticleProductApi from '@/api/ArticleProductApi';
import {namespace} from 'vuex-class';
import {
  SET_ARTICLE_PRODUCT,
  SET_ARTICLE_PRODUCTS,
  SET_PRODUCTARTICLE,
  SET_ALLARTICLE,
  SET_STATUS,
} from '@/store/mutationTypes';

export const articleProductModule = namespace('articleProduct');

export interface ArticleProduct {
  [key: string]: any;
}

interface ArticleProductState {
  article_products: ArticleProduct[];
  article_product: ArticleProduct | null;
  detailArticleProduct: ArticleProduct[];
  liatArticle: ArticleProduct[];
  status: ArticleProduct[];
}

export default <Module<ArticleProductState, RootState>>{
  namespaced: true,
  state: {
    article_products: [],
    article_product: null,
    detailArticleProduct: [],
    liatArticle: [],
    status: [],
  },
  mutations: {
    [SET_PRODUCTARTICLE](state, data) {
      state.detailArticleProduct = data;
    },
    [SET_ARTICLE_PRODUCTS](state, data) {
      state.article_products = data;
    },
    [SET_ARTICLE_PRODUCT](state, data) {
      state.article_product = data;
    },
    [SET_ALLARTICLE](state, data) {
      state.liatArticle = data;
    },
    [SET_STATUS](state, data) {
      state.status = data;
    },
  },
  actions: {
    async all({commit}, params = {}) {
      try {
        const {data} = await ArticleProductApi.all(params);
        if (!!params.paginate) {
          commit(SET_ARTICLE_PRODUCTS, data.data);
        } else {
          commit(SET_ARTICLE_PRODUCTS, data.data.data);
        }
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getAllArticle({commit}, params = {}) {
      try {
        const {data} = await ArticleProductApi.listAllArticle(params);
        if (!!params.paginate) {
          commit(SET_ALLARTICLE, data.data);
        } else {
          commit(SET_ALLARTICLE, data.data.data);
        }
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async detail({commit}, id) {
      try {
        const {data} = await ArticleProductApi.detail(id);
        commit(SET_ARTICLE_PRODUCT, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async create(_, payload) {
      try {
        const {data} = await ArticleProductApi.create(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async updateStatus(_, id) {
      try {
        const {data} = await ArticleProductApi.activeStatus(id);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async updateUseProduct(_, id) {
      try {
        const {data} = await ArticleProductApi.useProduct(id);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    // async delete(_, id) {
    //   try {
    //     const {data} = await ArticleProductApi.delete(id);
    //     return data;
    //   } catch (e) {
    //     return e.response.data;
    //   }
    // },
    async attachProduct(_, {id, payload}) {
      try {
        const {data} = await ArticleProductApi.attachProduct(id, payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async articleProductDetail({commit}, id) {
      try {
        const {data} = await ArticleProductApi.articleProduct(id);
        commit(SET_PRODUCTARTICLE, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async AttctDelete(_, {id, payload}) {
      try {
        const {data} = await ArticleProductApi.attactDelete(id, payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
  getters: {},
};
